import axios, { AxiosResponse } from 'axios'
import queryString from 'query-string'

import { Auth } from 'common/auth/auth'
import { BASE_API_URL, HttpCode } from 'common/http'
import { Region, RegionStore } from 'common/region/region'

const setupErrorHandler = () => {
  axios.interceptors.response.use(
    response => response,
    originalError => {
      const error = originalError ?? {}

      const errorResponse = error?.response ?? ({} as AxiosResponse)
      const { method, baseURL, url } = error?.config ?? {}
      const errorUrl = baseURL && url && `${baseURL}${url}`
      const defaultErrorMessage =
        method && errorUrl
          ? `Unknown error occurred while making ${method.toUpperCase()} request to ${errorUrl}`
          : 'Unknown error occurred'

      error.message = errorResponse.data?.message || error.message || defaultErrorMessage
      error.code = errorResponse.data?.code

      if (errorResponse.status === HttpCode.Unauthorized) {
        Auth.logout()
      }

      return Promise.reject(error)
    },
  )
}

const setupIndiaRequestHandler = () => {
  axios.interceptors.request.use(config => {
    const currentRegion = RegionStore.region

    if (currentRegion === Region.IN) {
      config.baseURL = `/in${config.baseURL}`
    }

    return config
  })
}

export const setupAxios = () => {
  axios.defaults.baseURL = BASE_API_URL
  axios.defaults.paramsSerializer = params =>
    queryString.stringify(params, { arrayFormat: 'none' })

  setupErrorHandler()
  setupIndiaRequestHandler()
}
